<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <div
        class="learning-code-item"
        v-bind="linkerProps"
        v-on="excludeInputListeners"
    >
        <div class="header">
            <XIcon
                content="f098"
                theme="main"
            />
            <XLabel>{{data.enterpriseCooperationSn}}</XLabel>
        </div>
        <div class="body">
            <div class="inner">
                <dl>
                    <dt>企业合作:</dt>
                    <dd>{{data.enterpriseCooperationName}}</dd>
                </dl>
                <dl>
                    <dt>学　　校:</dt>
                    <dd>{{data.schoolOrgName}}</dd>
                </dl>
                <dl>
                    <dt>核销截止:</dt>
                    <dd>{{data.writeOffEndTime | moment}}</dd>
                </dl>
                <dl>
                    <dt>状态更新:</dt>
                    <dd>{{data.updateTime | moment('YYYY-MM-DD HH:mm:ss')}}</dd>
                </dl>
            </div>
            <!--<XIcon
                content="f012"
                size="small"
                theme="g5"
            />-->
        </div>
        <div class="footer">
            <XButton
                :label="data.codeStatusName"
                :theme="data.codeStatus===10?'main':'g5'"
                link
            />
        </div>
    </div>
</template>

<script>
import { linkerMixin, listenersMixin } from 'packages/mixins';

export default {
    name: 'LearningCodeItem',
    mixins: [linkerMixin, listenersMixin],
    data() {
        return {};
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss">
.learning-code-item {
    display: block;
    background-color: $color-component-bgc;
    //border-radius: $padding;
    border: 1px solid $color-border;
    overflow: hidden;
    @include boxShadow();

    > .header {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .x-icon {
            margin-right: $margin-small;
        }
        > .x-label {
            flex: 1;
            font-weight: bold;
        }
    }
    > .body {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .inner {
            flex: 1;
            dl {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                + dl {
                    margin-top: $margin-small;
                }
                > dt {
                    flex: 0 0 auto;
                }
                > dd {
                    flex: 1;
                }
            }
        }
    }
    > .footer {
        margin: $padding 0;
        text-align: right;
    }
}
</style>
